// extracted by mini-css-extract-plugin
export default {"filterSelect":"filterSelect_filterSelect__7Bp6E","icon":"filterSelect_icon__yj+Ik","selectElement":"filterSelect_selectElement__en5+U"};